const formdetailsValidation = (
  forum,
  languageId,
  sectorId,
  countryId,
  subjectId,
  keywords,
  disclaimerid
) => {
  const errors = {};

  if (!forum || forum.trim() === "") {
    errors.forum = "FirstName cannot be empty.";
  }

  if (!Array.isArray(languageId) || languageId.length === 0) {
    errors.languageId = "Language cannot be empty.";
  }
  if (!Array.isArray(sectorId) || sectorId.length === 0) {
    errors.sectorId = "Sector cannot be empty.";
  }

  if (!Array.isArray(countryId) || countryId.length === 0) {
    errors.countryId = "Country cannot be empty.";
  }

  if (!Array.isArray(subjectId) || subjectId.length === 0) {
    errors.subjectId = "Subject cannot be empty.";
  }

  if (!keywords || keywords.trim() === "") {
    errors.keywords = "FirstName cannot be empty.";
  }
  if (!disclaimerid) {
    errors.disclaimerid = "Sponsor Email cannot be empty.";
  }

  return errors;
};

export default formdetailsValidation;
